import React from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
  InputAdornment
} from "@mui/material";
import dayjs from "dayjs";
import "dayjs/locale/fr";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { ReactComponent as PageIcon } from "../../../../assets/img/personas/fermier.svg";
import { Trans } from "react-i18next";
import ActionButtons from "../ActionButtons";
import { ReactComponent as BackIcon } from "../../../../assets/img/leftArrow.svg";
import TelInput from "components/TelInput";



const validationSchema = yup.object({
  email: yup.string(),
  lastName: yup.string().required("Veuillez remplir ce champ"),
  firstName: yup.string().required("Veuillez remplir ce champ"),
  phoneNumber: yup
  .number("Téléphone non valide, réessayer")
  .required("Veuillez entrer un numéro de téléphone")
  .min(6, "Non valide, réessayer")
});
 
const StructureOwner = ({ onSubmit, onBack, data: formData }) => {
  const [idError, setIdError] = React.useState(false);

  const filterPhoneNumber = (number) => {
    if (number.substring(0, 4) === "+229") {
      return number.slice(4);
    }
    return number;
  };

  const formik = useFormik({
    initialValues: {
      ...{
        email: "",
        lastName: "",
        firstName: "",
        phoneNumber: "",
      },
      ...formData,
    },
    onSubmit: (vals) => {
      if (vals["phoneNumber"].substring(0, 4) !== "+229") {
        vals["phoneNumber"] = `+229${vals.phoneNumber}`;
      }
      console.log(vals)
      onSubmit(vals);
      setTimeout(() => {}, 800);
    },
  });

  return (
    <div className="px-4 sm:px-0">
      <div className="flex flex-col justify-center py-16">
        <div className="flex flex-col text-center items-center mb-10">
          <PageIcon />
          <div className="mt-9">
            <div
              className="absolute -left-20 top-1/2 -translate-y-1/2 cursor-pointer"
              onClick={onBack}
            >
              <BackIcon />
            </div>
            <Typography variant="title">
              <Trans>formTitles.addPrestataireTitle</Trans>
            </Typography>
            <Typography variant="title" fontSize={20} fontWeight={200}>
              <div style={{ background: "darkred", color: "white" }} className="p-4 mt-4 text-left">
               <h4 style={{ color: "white" }}>Note</h4>
               <p style={{ color: "white" }}> 
                Notez que votre compte devra faire l'objet de validation avant que vous ne puissiez avoir accès aux differents services. <br/>
                Vous recevrez une reponse sous les 48 heures. Si non, veuillez contactez le support technique pour une prise en charge.
                </p>  
              </div>
          </Typography>
          </div>
        </div>

        <div className="mt-10">
          <Typography variant="title">
            <Trans>formTitles.prestataireInformation</Trans>
          </Typography>
        </div>

        <form>
          <div className="mt-12 grid sm:grid-cols-2 gap-y-6 sm:gap-x-9">
            <div className="mb-4">
              <FormControl fullWidth>
                <TextField
                  name="firstName"
                  label="Prénom *"
                  value={formik.values.firstName}
                  error={
                    formik.touched.firstName && Boolean(formik.errors.firstName)
                  }
                  helperText={
                    formik.touched.firstName && formik.errors.firstName
                  }
                  onChange={formik.handleChange}
                />
              </FormControl>
            </div>
            <div className="mb-4">
              <FormControl fullWidth>
                <TextField
                  name="lastName"
                  label="Nom de famille *"
                  value={formik.values.lastName}
                  error={
                    formik.touched.lastName && Boolean(formik.errors.lastName)
                  }
                  helperText={formik.touched.lastName && formik.errors.lastName}
                  onChange={formik.handleChange}
                />
              </FormControl>
            </div>

            <div className="mb-4">
              <FormControl fullWidth>
                <TelInput
                  name="phoneNumber"
                  type="number"
                  value={filterPhoneNumber(formik.values.phoneNumber)}
                  error={
                    formik.touched.phoneNumber &&
                    Boolean(formik.errors.phoneNumber)
                  }
                  helperText={
                    formik.touched.phoneNumber && formik.errors.phoneNumber
                  }
                  onChange={formik.handleChange}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <div className="bg-[#ededed] flex h-[53px] justify-center items-center -ml-[14px] px-5">
                          <img
                            src={require("assets/img/benin.png")}
                            style={{ height: 14, marginRight: 5 }}
                            alt=""
                          />
                          <small className="text-sm">+229</small>
                        </div>
                      </InputAdornment>
                    ),
                  }}
                />
              </FormControl>
            </div>
            <div className="mb-4">
              <FormControl fullWidth>
                <TextField
                  name="email"
                  label="Email"
                  type="email"
                  value={formik.values.email}
                  error={formik.touched.email && Boolean(formik.errors.email)}
                  helperText={formik.touched.email && formik.errors.email}
                  onChange={formik.handleChange}
                />
              </FormControl>
            </div>

            {/* <div className="">
              <FormControl
                fullWidth
                error={formik.touched.idType && Boolean(formik.errors.idType)}
              >
                <InputLabel>Type de pièce d’identité</InputLabel>
                <Select
                  name="idType"
                  label="Type de pièce d’identité"
                  placeholder="Sélectionner"
                  value={formik.values.idType}
                  onChange={formik.handleChange}
                >
                  {[
                    {
                      label: "Carte d'Idenité Nationale",
                      value: "NATIONAL_ID",
                    },
                    {
                      label: "Certificat d'Identification Personnelle",
                      value: "PASSPORT",
                    },
                    { label: "Carte Lépi", value: "NPI" },
                    { label: "RAVIP", value: "RAVIP" },
                    { label: "Carte biométrique", value: "FARMER_ID" },
                  ].map((arr) => (
                    <MenuItem key={arr.label} value={arr.value}>
                      {arr.label}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText>
                  {formik.touched.idType && formik.errors.idType}
                </FormHelperText>
              </FormControl>
            </div>
            <div className="">
              <FormControl fullWidth>
                <TextField
                  name="idDeLaCarte"
                  label="N° de la carte"
                  type="text"
                  value={formik.values.idDeLaCarte.trim()}
                  error={
                    formik.touched.idDeLaCarte &&
                    Boolean(formik.errors.idDeLaCarte)
                  }
                  helperText={
                    formik.touched.idDeLaCarte && formik.errors.idDeLaCarte
                  }
                  onChange={formik.handleChange}
                />
              </FormControl>
            </div>
           */}
          </div>
          <div className="flex justify-end mt-20 gap-6">
            <ActionButtons onNextStep={formik.handleSubmit} />
          </div>
        </form>
      </div>
    </div>
  );
};

export default StructureOwner;
